export const MAX_ITEMS_AMOUNT = 4;
export const LIST_ITEM_HEIGHT = 37; // Reflects the list item height in pixels - from src/packages/polaris/apps/common/src/ui/connection/connection-item/index.tsx
export const LIST_ITEM_BORDER_BOTTOM_HEIGHT = 1;
